/**
 * getQueryString
 * @param
 */
export function getQueryString ({ city, zipcode, street, houseNumber }) {
    return `?zipcode=${zipcode}&city=${city}&street=${street}&housenumber=${houseNumber}`;
}

/**
 * Decodes url encoded response data values
 *
 * example: 'Br\u00fchler Str.' -> 'Brühler Str.'
 * @param
 */
 export function getDecodedResponseData (responseData: Object) {
    const responseDataStringDecoded = decodeURI(JSON.stringify(responseData));

    return JSON.parse(responseDataStringDecoded);
}
